import { curry } from 'ramda';
import { renderWhenTrue } from '../../../utils/rendering';

export const renderOpenTooltip = curry((renderer, tooltip) => renderWhenTrue(renderer)(tooltip.isOpen));
